let store = {};

if (!global.IS_SERVER) {
  const Basil = require('basil.js');
  store = new Basil({
    namespace: 'tic_cart',
    expireDays: 1,
  });
}

export default store;
